import React, { useState, useEffect, useContext } from 'react'

import { makeStyles, createStyles } from '@material-ui/core/styles'

import MUIButton from '@material-ui/core/Button'
import MUIBox from '@material-ui/core/Box'

const useStyles = makeStyles((theme: Theme) => createStyles({
  defaultButton: {
    textTransform: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
  textButton: {
    textTransform: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
    paddingLeft: 0,
    paddingRight: 0
  },
}))

export const Button = ({ color, variant, icon, iconPosition='left', children, ...props }) => {
  const classes = useStyles()  
  
  let variantVal = variant || 'text'
  let colorVal = color || 'primary'
  let className = classes.defaultButton
  
  if (variantVal == 'text')
    className = classes.textButton
    
  let textColor = variantVal == 'contained' ? (colorVal !== 'default' ? '#fff' : 'black') : 'auto'
  if (colorVal == 'disabled')
    textColor = '#aaa'
  
  let iconColor = colorVal  
  if (variantVal == 'contained')
    // Set icon color
    iconColor = 'white'
  
  
  return (
    <MUIButton
      color={colorVal}
      className={className}
      variant={variantVal}
      style={{minWidth: icon ? 0 : '64px'}}
      {...props}
      >
      { icon ?
        <MUIBox display='flex' alignItems='center'
          flexDirection={iconPosition == 'right' ? 'row-reverse' : 'row'}
          >
          { React.createElement(icon, {
              style: { color: iconColor }
            })
          }
          <div style={{ width: 4 }}/>
          <span style={{ color: textColor }}>
            { children }
          </span>
        </MUIBox>
        :
        <span style={{ color: textColor }}>
          { children }
        </span>
      }
    </MUIButton>
  )
}

export default Button